<template>
  <img fetchpriority="high" class="navbar-brand__logo" :src="$whitelabel.logoHeader" :alt="$whitelabel.storeName"
    v-if="$whitelabel.showHeaderLogo" />
  <span v-else-if="$whitelabel.short.toLowerCase() !== 'urlaubsguru'" class="is-hidden-touch"><b-icon icon="search"
      size="is-small"></b-icon> &nbsp;{{ $t('general.find-vacation') }}</span>
  <span v-else class="is-hidden-touch"><b-icon icon="home" size="is-small"></b-icon> &nbsp;Urlaubsgutscheine - bis zu
    70% günstiger</span>
</template>

<script>
export default {
  name: 'NavHomeBrand',
}
</script>
